import useDefinedContext from "hooks/useDefinedContext";
import XAxisStoreContext from "../contexts/XAxisStoreContext";

interface UseXAxisProps {}

function useXAxis(props?: UseXAxisProps) {
  return useDefinedContext(XAxisStoreContext);
}

export default useXAxis;
